var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtheracc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6743 19.446C15.6743 16.4852 18.0976 14.064 21.0609 14.064C24.0243 14.064 26.4476 16.4852 26.4476 19.446C26.4476 21.2459 25.5507 22.8559 24.1828 23.8343C24.9508 24.0681 25.6807 24.3853 26.3601 24.775C25.4279 24.9104 24.563 25.2533 23.8137 25.7553C22.9558 25.4718 22.0302 25.3174 21.0609 25.3174C16.7841 25.3174 13.3565 28.3235 12.8432 32.1673H19.1022C19.2319 32.1655 19.3608 32.1895 19.4812 32.2378C19.6016 32.2862 19.7112 32.358 19.8036 32.449C19.896 32.5401 19.9694 32.6485 20.0195 32.7682C20.0696 32.8878 20.0954 33.0162 20.0954 33.1459C20.0954 33.2755 20.0696 33.4039 20.0195 33.5235C19.9694 33.6432 19.896 33.7517 19.8036 33.8427C19.7112 33.9338 19.6016 34.0055 19.4812 34.0539C19.3608 34.1023 19.2319 34.1262 19.1022 34.1244H11.7567C11.497 34.1244 11.2479 34.0213 11.0642 33.8378C10.8806 33.6543 10.7774 33.4054 10.7773 33.1459C10.7773 28.7684 13.8052 25.0927 17.9391 23.8343C16.5712 22.8559 15.6743 21.2459 15.6743 19.446ZM24.4888 19.446C24.4888 17.5429 22.9657 16.0211 21.0609 16.0211C19.1562 16.0211 17.6331 17.5429 17.6331 19.446C17.6331 21.3492 19.1562 22.871 21.0609 22.871C22.9657 22.871 24.4888 21.3492 24.4888 19.446Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.8086,
    y: 28.1226,
    width: 11.0399,
    height: 2.16089,
    rx: 0.982178,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6328,
    y: 25.3901,
    width: 5.80964,
    height: 2.16089,
    rx: 0.982178,
    transform: "rotate(37.9146 27.6328 25.3901)",
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0078,
    y: 33.2072,
    width: 11.0399,
    height: 2.16089,
    rx: 0.982178,
    transform: "rotate(180 32.0078 33.2072)",
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1836,
    y: 35.9396,
    width: 5.80964,
    height: 2.16089,
    rx: 0.982178,
    transform: "rotate(-142.085 25.1836 35.9396)",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtheracc);
export default __webpack_public_path__ + "static/media/otheracc.ed8223c59ed8efd582e3bb2d3ae7e5f4.svg";
export { ForwardRef as ReactComponent };